import { isAxiosError } from 'axios';
import { redirect } from 'react-router';
import type { User } from '@/common/user';
import { getProfileOptions } from '@/queries/users/profile';
import { queryClient } from '../../queries/query.client';

export type ProfileLoaderType = {
	profile: User;
};

export async function profileLoader() {
	try {
		const { data: user, error, errorMessage } = await queryClient.ensureQueryData(getProfileOptions());
		if (error || !user) {
			console.error('Error fetching profile:', errorMessage, error);
			throw redirect('/login');
		}
		return {
			profile: user,
		} as ProfileLoaderType;
	} catch (error) {
		isAxiosError(error) && error.response?.status === 401
			? redirect('/login')
			: console.error('Unexpected error fetching profile:', error);
		throw redirect('/login');
	}
}
